"use client"

import { useState, useEffect } from "react"
import { FaBars, FaTimes } from "react-icons/fa"
import { HashLink } from 'react-router-hash-link'
import { useLocation } from 'react-router-dom'
import "./navbar.css"
import logoImage from "../assets/images/Reactiva.png"

const CustomNavbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [activeSection, setActiveSection] = useState("home")
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
      
      // Actualizar la sección activa basada en el scroll
      const sections = document.querySelectorAll("section[id]")
      let currentSection = "home"
      
      sections.forEach((section) => {
        const sectionTop = section.offsetTop
        const sectionHeight = section.offsetHeight
        
        if (window.scrollY >= sectionTop - 100 && 
            window.scrollY < sectionTop + sectionHeight - 100) {
          currentSection = section.id
        }
      })
      
      setActiveSection(currentSection)
    }
    
    window.addEventListener("scroll", handleScroll)
    
    // Si la URL tiene un hash, desplazar a esa sección
    if (location.hash) {
      const element = document.querySelector(location.hash)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" })
        }, 100)
      }
    }
    
    return () => window.removeEventListener("scroll", handleScroll)
  }, [location])

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  const navItems = [
    { href: "#services", label: "Proyectos", id: "services" },
    { href: "#about", label: "Nosotros", id: "about" },
    { href: "#team", label: "Aliados", id: "team" },
    { href: "#contact", label: "Contacto", id: "contact" },
    { href: "http://190.249.179.10:8071/web/login?db=proyectos", label: "Portal", id: "portal", external: true }
  ]

  return (
    <>
      {/* Floating Navbar */}
      <nav className={`floating-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-content">
          {/* Logo */}
          <div className="navbar-logo">
            <HashLink to="/#home" onClick={closeMobileMenu}>
              <img src={logoImage || "/placeholder.svg"} alt="Reactiva Logo" className="logo-image" />
            </HashLink>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-links">
            {navItems.map((item) => (
              item.external ? (
                <a
                  key={item.id}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`nav-item ${activeSection === item.id ? "active" : ""}`}
                >
                  {item.label}
                </a>
              ) : (
                <HashLink
                  key={item.id}
                  to={`/${item.href}`}
                  className={`nav-item ${activeSection === item.id ? "active" : ""}`}
                  onClick={closeMobileMenu}
                  scroll={(el) => {
                    const yOffset = -80; // Ajusta según la altura de tu navbar
                    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                  }}
                >
                  {item.label}
                </HashLink>
              )
            ))}
          </div>

          {/* Mobile Toggle */}
          <button className="mobile-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-content">
          {navItems.map((item, index) => (
            item.external ? (
              <a
                key={item.id}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`mobile-nav-item ${activeSection === item.id ? "active" : ""}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={closeMobileMenu}
              >
                {item.label}
              </a>
            ) : (
              <HashLink
                key={item.id}
                to={`/${item.href}`}
                className={`mobile-nav-item ${activeSection === item.id ? "active" : ""}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={closeMobileMenu}
                scroll={(el) => {
                  const yOffset = -80;
                  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                  window.scrollTo({ top: y, behavior: 'smooth' });
                  closeMobileMenu();
                }}
              >
                {item.label}
              </HashLink>
            )
          ))}
        </div>
      </div>

      {/* Mobile Backdrop */}
      {mobileMenuOpen && <div className="mobile-backdrop" onClick={closeMobileMenu} />}
    </>
  )
}

export default CustomNavbar